import { z } from "zod";

export const userDataSchema = z.object({
  organisation: z.string().trim().min(1).optional(),
  speciality: z.string().trim().min(1),
  firstName: z.string().trim().min(1),
  lastName: z.string().trim().min(1),
  language: z.string().optional(),
});
